import React from 'react';
import { CHECKOUT_URL } from '../../data/content';
import { CtaButton } from '../ui/CtaButton';
import { SectionLabel } from '../ui/SectionLabel';
export function FinalCta() {
  return <section aria-labelledby="cta-final-title" className="w-full bg-gradient-to-b from-ink-900 to-pitch" data-id="element-86" data-mp="1np9cul1hkh86">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-5 py-20 text-center" data-id="element-87" data-mp="1sn15jh9yg7df">
        <SectionLabel tone="gold" data-id="element-88" data-mp="1eo1rt4nzdcw1">Oferta sólo por hoy</SectionLabel>
        <h2 id="cta-final-title" className="mt-6 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-89" data-mp="1ipwry5u6dk88">
          MÉTODO PARA PADRES DE FUTBOLISTAS — 12 capítulos + 2 bonos
        </h2>
        <p className="mt-8 text-lg font-semibold text-subtle line-through" data-id="element-90" data-mp="19of606u36obm">$50.000</p>
        <p className="mt-1 font-display text-6xl font-black text-brand-gold md:text-7xl" data-id="element-91" data-mp="2z3mzxnof0sn5">$19.990</p>
        <div className="mt-9" data-id="element-92" data-mp="343rfnbhi1jcb">
          <CtaButton size="xl" href={CHECKOUT_URL} data-id="element-93" data-mp="341wxg4xm45bx">
            Descargar el método por $19.990
          </CtaButton>
        </div>
        <p className="mt-5 text-sm text-subtle" data-id="element-94" data-mp="270l4x99o4f8">
          🔒 Pago seguro · ⚡ Acceso inmediato · ✅ Garantía de 7 días
        </p>
      </div>
    </section>;
}